const ONE_DAY_MS = 86_400_000;
/** A day of slack covers a caller whose local date runs ahead of UTC. */
export function isShipDateTooFarAhead(date) {
    return date.getTime() > Date.now() + ONE_DAY_MS;
}
//# sourceMappingURL=is-ship-date-too-far-ahead.js.map